import React from 'react';
import { Badge } from '@chakra-ui/react';

export default function StatusBadge({ status, ...props }) {
  const normalized = (status || '').toLowerCase();
  let colorScheme = 'gray';
  if (normalized === 'passed') colorScheme = 'green';
  else if (normalized === 'failed') colorScheme = 'red';
  else if (normalized === 'skipped') colorScheme = 'yellow';
  else if (normalized === 'running') colorScheme = 'blue';
  return (
    <Badge colorScheme={colorScheme} textTransform="capitalize" {...props}>
      {normalized || 'unknown'}
    </Badge>
  );
}


